define.alias("shared/components/shared/ui/social-set-switcher/social-set", "preview-grid/components/shared/ui/social-set-switcher/social-set");